export const ALL_MARKET_EXECUTIVE_REQUEST = "ALL_MARKET_EXECUTIVE_REQUEST";
export const ALL_MARKET_EXECUTIVE_SUCCESS = "ALL_MARKET_EXECUTIVE_SUCCESS";
export const ALL_MARKET_EXECUTIVE_FAILED = "ALL_MARKET_EXECUTIVE_FAILED";

export const SINGLE_MARKET_EXECUTIVE_REQUEST = "SINGLE_MARKET_EXECUTIVE_REQUEST";
export const SINGLE_MARKET_EXECUTIVE_SUCCESS = "SINGLE_MARKET_EXECUTIVE_SUCCESS";
export const SINGLE_MARKET_EXECUTIVE_FAILED = "SINGLE_MARKET_EXECUTIVE_FAILED";

